import PropTypes from 'prop-types';
import { Button, Switch } from 'ypf-pas-general-ui-components';
import './HeaderProviderForm.scss';

const HeaderProviderForm = (props) => {
  const {
    createSDS,
    createASDS,
    disabled,
    businessUnitSwitch,
    buttonAddProvider,
    onChangeSwitch,
    label
  } = props;

  return (
    <div className="d-flex align-items-center justify-content-between">
      <div className="header-provider-label">{label}</div>
      <div className="d-flex align-items-center gap-4 w-100 justify-content-center">
        <div className="d-flex align-items-center">
          <h6 className="mx-2 my-0">Otras unidades de negocio</h6>
          <Switch
            checked={businessUnitSwitch}
            disabled={disabled}
            falseLabel="NO"
            name="businessUnitSwitch"
            onChange={onChangeSwitch}
            size="sm"
            trueLabel="SÍ"
          />
        </div>
      </div>
      {/* Verificar si las banderas createSDS son necesarias
          {/* porque si los containers son para cada uno de los componentes que lo llaman no seria necesario otra bandera */}
      {(createSDS || !createASDS) && (
        <Button
          colorIcon="primary"
          disabled={buttonAddProvider?.disabled}
          fontSizeLabel="15px"
          icon={buttonAddProvider?.icon}
          iconRight
          label="Agregar proveedor"
          onClick={buttonAddProvider?.onClick}
          sizeIcon="17px"
          type="button"
          variant="light-gray"
          widthButton="180px"
        />
      )}
    </div>
  );
};

HeaderProviderForm.propTypes = {
  createSDS: PropTypes.bool,
  createASDS: PropTypes.bool,
  disabled: PropTypes.bool,
  businessUnitSwitch: PropTypes.bool,
  buttonAddProvider: PropTypes.objectOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      icon: PropTypes.elementType,
      onClick: PropTypes.func
    })
  ),
  onChangeSwitch: PropTypes,
  label: PropTypes.element
};

HeaderProviderForm.defaultProps = {
  createSDS: false,
  createASDS: false,
  disabled: false,
  businessUnitSwitch: false,
  buttonAddProvider: {},
  onChangeSwitch: () => {},
  label: ''
};

export default HeaderProviderForm;
